// =============================================================================
// VOICE TYPES AND DATA
// =============================================================================

/**
 * Voice interface for character voice selection
 */
export interface Voice {
  name: string;
  gender: string;
  rita_voice_id: string;
  audio_url: string;
  provider: string;
  provider_voice_id: string;
  language: string;
  fish_speed: number;
  is_HD: boolean;
  price: number;
}

/**
 * Centralized voice data - contains all available voices
 */
export const AVAILABLE_VOICES: Voice[] = [
  // Female voices
  {
    name: "Lara",
    gender: "female",
    rita_voice_id: "544bd093-092d-4a4b-aabb-3f24ef52c01f",
    audio_url: "/audio_samples/female/Lara_544bd093-092d-4a4b-aabb-3f24ef52c01f.wav",
    provider: "deepinfra",
    provider_voice_id: "af_bella",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: false,
    price: 0
  },
  {
    name: "Cherry",
    gender: "female",
    rita_voice_id: "168fe0d3-d64e-4b91-9157-2632a0a77d0c",
    audio_url: "/audio_samples/female/Cherry_168fe0d3-d64e-4b91-9157-2632a0a77d0c.wav",
    provider: "deepinfra",
    provider_voice_id: "af_heart",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: false,
    price: 0
  },
  {
    name: "Elara",
    gender: "female",
    rita_voice_id: "0926bdc2-8862-4690-b467-a938a362d28c",
    audio_url: "/audio_samples/female/Elara_0926bdc2-8862-4690-b467-a938a362d28c.wav",
    provider: "deepinfra",
    provider_voice_id: "af_river",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: false,
    price: 0
  },
  {
    name: "Obsidian",
    gender: "female",
    rita_voice_id: "0870586d-35c7-494e-b360-5fe2b7f528fb",
    audio_url: "/audio_samples/female/Obsidian_0870586d-35c7-494e-b360-5fe2b7f528fb.wav",
    provider: "deepinfra",
    provider_voice_id: "af_kore",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: false,
    price: 0
  },
  {
    name: "Regina",
    gender: "female",
    rita_voice_id: "13b1aca4-c720-4278-9d26-f7e4b8b63852",
    audio_url: "/audio_samples/female/Regina_13b1aca4-c720-4278-9d26-f7e4b8b63852.wav",
    provider: "deepinfra",
    provider_voice_id: "af_jessica",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: false,
    price: 0
  },
  {
    name: "Quiet",
    gender: "female",
    rita_voice_id: "76b78e53-2d9d-4d3b-be47-20781d4cb75b",
    audio_url: "/audio_samples/female/Quiet_76b78e53-2d9d-4d3b-be47-20781d4cb75b.mp3",
    provider: "cartesia",
    provider_voice_id: "753f276b-2221-4a49-811c-b0592f89d05e",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Chatty",
    gender: "female",
    rita_voice_id: "e763832c-efb9-4c6c-aa56-bc49e2ce8e8e",
    audio_url: "/audio_samples/female/Chatty_e763832c-efb9-4c6c-aa56-bc49e2ce8e8e.mp3",
    provider: "cartesia",
    provider_voice_id: "cb3dab59-86fa-48a1-8f01-69c1423bcbab",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Confident",
    gender: "female",
    rita_voice_id: "cf2c574f-eab2-4d8c-aee0-ecd079c6fb1b",
    audio_url: "/audio_samples/female/Confident_cf2c574f-eab2-4d8c-aee0-ecd079c6fb1b.mp3",
    provider: "cartesia",
    provider_voice_id: "fbf4c73a-5387-443c-8fb6-1fae5d5b2643",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Crush",
    gender: "female",
    rita_voice_id: "6bcd788a-f0ae-44e6-81f3-8e9fe07363eb",
    audio_url: "/audio_samples/female/Crush_6bcd788a-f0ae-44e6-81f3-8e9fe07363eb.mp3",
    provider: "cartesia",
    provider_voice_id: "c85fbf73-9f54-424e-b0d3-62cd2a46bb23",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Cute",
    gender: "female",
    rita_voice_id: "baac939a-206c-4312-8a07-a037368c556a",
    audio_url: "/audio_samples/female/Cute_baac939a-206c-4312-8a07-a037368c556a.mp3",
    provider: "cartesia",
    provider_voice_id: "6669a8f2-986f-4a11-b133-6a463d9c834f",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Dramatic",
    gender: "female",
    rita_voice_id: "79734d59-d67b-4aa2-bb98-56bdc1ebc2e6",
    audio_url: "/audio_samples/female/Dramatic_79734d59-d67b-4aa2-bb98-56bdc1ebc2e6.mp3",
    provider: "cartesia",
    provider_voice_id: "8ee5a024-bbc3-48fe-8799-abab485bc699",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Nurturing",
    gender: "female",
    rita_voice_id: "6c81499a-571e-46b5-95f7-083a17d8aaa0",
    audio_url: "/audio_samples/female/Nurturing_6c81499a-571e-46b5-95f7-083a17d8aaa0.mp3",
    provider: "cartesia",
    provider_voice_id: "f69ab66f-4348-45cd-9a9c-193b65c8c5eb",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Shy",
    gender: "female",
    rita_voice_id: "033ca74f-b86c-492d-a87f-bc07ea916c31",
    audio_url: "/audio_samples/female/Shy_033ca74f-b86c-492d-a87f-bc07ea916c31.mp3",
    provider: "cartesia",
    provider_voice_id: "29708bb6-76df-43be-ae75-ad8279869d61",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Sweet",
    gender: "female",
    rita_voice_id: "4616dc78-2a44-41cf-bbd6-e25118f03763",
    audio_url: "/audio_samples/female/Sweet_4616dc78-2a44-41cf-bbd6-e25118f03763.mp3",
    provider: "cartesia",
    provider_voice_id: "8e6ced47-5a26-4595-aab7-0f4e25b81d38",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Younger Sister",
    gender: "female",
    rita_voice_id: "8bb215e3-f88d-480f-ae38-ad40c041e1fe",
    audio_url: "/audio_samples/female/Younger sister_8bb215e3-f88d-480f-ae38-ad40c041e1fe.mp3",
    provider: "cartesia",
    provider_voice_id: "b6416cb5-f1c9-4446-ab88-fb2494a9bedf",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },

  // Male voices
  {
    name: "Cassian",
    gender: "male",
    rita_voice_id: "27ca13eb-76c0-4c88-a468-19bcb1408621",
    audio_url: "/audio_samples/male/Cassian_27ca13eb-76c0-4c88-a468-19bcb1408621.wav",
    provider: "deepinfra",
    provider_voice_id: "am_onyx",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: false,
    price: 0
  },
  {
    name: "Damien",
    gender: "male",
    rita_voice_id: "76ec3d34-a6c9-45f4-8aa3-1a8befef3087",
    audio_url: "/audio_samples/male/Damien_76ec3d34-a6c9-45f4-8aa3-1a8befef3087.wav",
    provider: "deepinfra",
    provider_voice_id: "am_echo",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: false,
    price: 0
  },
  {
    name: "Harold",
    gender: "male",
    rita_voice_id: "14af5c35-7be8-4bbd-96d0-27908bb44fb3",
    audio_url: "/audio_samples/male/Harold_14af5c35-7be8-4bbd-96d0-27908bb44fb3.wav",
    provider: "deepinfra",
    provider_voice_id: "am_michael",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: false,
    price: 0
  },
  {
    name: "Leo",
    gender: "male",
    rita_voice_id: "1bcec784-aa8e-4e39-80d8-ff2860f6dc8e",
    audio_url: "/audio_samples/male/Leo_1bcec784-aa8e-4e39-80d8-ff2860f6dc8e.wav",
    provider: "deepinfra",
    provider_voice_id: "bm_fable",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: false,
    price: 0
  },
  {
    name: "Marcus",
    gender: "male",
    rita_voice_id: "f6942d35-7165-4c31-bdbd-94844973cdc5",
    audio_url: "/audio_samples/male/Marcus_f6942d35-7165-4c31-bdbd-94844973cdc5.wav",
    provider: "deepinfra",
    provider_voice_id: "am_liam",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: false,
    price: 0
  },
  {
    name: "Calm",
    gender: "male",
    rita_voice_id: "a2ef33cd-56c6-410f-8cf8-f2a1b046adf7",
    audio_url: "/audio_samples/male/Calm_a2ef33cd-56c6-410f-8cf8-f2a1b046adf7.mp3",
    provider: "cartesia",
    provider_voice_id: "e61e7ec8-a48b-43a1-86bc-fe57034706e6",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Boss",
    gender: "male",
    rita_voice_id: "5cf9a295-e50a-4401-84b1-ca136621c31f",
    audio_url: "/audio_samples/male/Boss_5cf9a295-e50a-4401-84b1-ca136621c31f.mp3",
    provider: "cartesia",
    provider_voice_id: "c19abf67-40a5-444f-b13c-09b139dde25b",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Brother",
    gender: "male",
    rita_voice_id: "d9ce2539-6551-47ce-9648-f03fbe1c23ea",
    audio_url: "/audio_samples/male/Brother_d9ce2539-6551-47ce-9648-f03fbe1c23ea.mp3",
    provider: "cartesia",
    provider_voice_id: "65845241-208d-447c-a571-a95270a237bc",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Calm",
    gender: "female",
    rita_voice_id: "8dae2bcd-dfad-43a5-9402-f84f2ad32083",
    audio_url: "/audio_samples/female/Calm_8dae2bcd-dfad-43a5-9402-f84f2ad32083.mp3",
    provider: "cartesia",
    provider_voice_id: "999d90d1-7dfc-448f-acac-975555aa05ab",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Captain",
    gender: "male",
    rita_voice_id: "7256e2c7-6bd7-4b21-b0a5-d02430b634ee",
    audio_url: "/audio_samples/male/Captain_7256e2c7-6bd7-4b21-b0a5-d02430b634ee.mp3",
    provider: "cartesia",
    provider_voice_id: "c76c2b71-137a-440c-b246-2577fc6a32b5",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Curious",
    gender: "male",
    rita_voice_id: "3def78e1-661c-4b29-b429-d285d6a1dc60",
    audio_url: "/audio_samples/male/Curious_3def78e1-661c-4b29-b429-d285d6a1dc60.mp3",
    provider: "cartesia",
    provider_voice_id: "6729bc39-0c2f-42ef-bc1b-c395025fc9ac",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Dark",
    gender: "male",
    rita_voice_id: "34d4acdb-6e1d-4bc1-9e80-bee0bbe8ce90",
    audio_url: "/audio_samples/male/Dark_34d4acdb-6e1d-4bc1-9e80-bee0bbe8ce90.mp3",
    provider: "cartesia",
    provider_voice_id: "924ad499-bd68-433f-b88c-0a31e395675d",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Deep",
    gender: "male",
    rita_voice_id: "c3f29ba5-0e2d-4ae4-b452-22969f695aa2",
    audio_url: "/audio_samples/male/Deep_c3f29ba5-0e2d-4ae4-b452-22969f695aa2.mp3",
    provider: "cartesia",
    provider_voice_id: "849ca2a0-e187-49a8-9973-2aaa1a58a8cd",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Peter",
    gender: "male",
    rita_voice_id: "ea4442c4-893c-4a3f-815e-8f11eec0dd45",
    audio_url: "/audio_samples/male/Peter_ea4442c4-893c-4a3f-815e-8f11eec0dd45.mp3",
    provider: "cartesia",
    provider_voice_id: "6f290973-07f9-4117-9490-8a75b84f7a83",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Quiet",
    gender: "male",
    rita_voice_id: "f43a6c52-6754-48bd-acdd-18547bb417e7",
    audio_url: "/audio_samples/male/Quiet_f43a6c52-6754-48bd-acdd-18547bb417e7.mp3",
    provider: "cartesia",
    provider_voice_id: "ae0a394c-109a-47ae-b222-be4e26a10ce2",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Traveller",
    gender: "male",
    rita_voice_id: "b56b60d3-fc6b-4063-8b50-895cb106905c",
    audio_url: "/audio_samples/male/Traveller_b56b60d3-fc6b-4063-8b50-895cb106905c.mp3",
    provider: "cartesia",
    provider_voice_id: "54068d6e-51da-4937-8f41-aa91ea869099",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  },
  {
    name: "Youthful",
    gender: "male",
    rita_voice_id: "0fd1c240-3731-46fa-8be3-4fe1a57fd2e8",
    audio_url: "/audio_samples/male/Youthful_0fd1c240-3731-46fa-8be3-4fe1a57fd2e8.mp3",
    provider: "cartesia",
    provider_voice_id: "12d40348-60a1-47c4-92f4-6eb18563c6d9",
    language: "en-US",
    fish_speed: 1.0,
    is_HD: true,
    price: 5
  }
];
